export const LANGUAGE_OPTIONS = [
  { identifier: "en", name: "English" },
  { identifier: "hn", name: "Hindi" },
  { identifier: "de", name: "German" },
  { identifier: "sp", name: "Spanish" },
];
